import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';
import { getRolesAsync } from './getRolesSlice';

interface IDeleteRoleResponse {
  status?: boolean;
  message?: string;
  errors?: IApiResponseError[];
}

const initialState: IApiState<IDeleteRoleResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const deleteRoleAsync = createAsyncThunk(
  'role/delete',
  async (roleId: string, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId =
        localStorage.getItem('businessId') ||
        state.auth.value?.data?.user?.businesses?.[0]?.id;

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.delete<IDeleteRoleResponse>(
        `/roles/${roleId}`,
        config
      );

      dispatch(getRolesAsync());

      return data;
    } catch (err) {
      const error = err as AxiosError<IDeleteRoleResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const roleDeleteSlice = createSlice({
  name: 'role/delete',
  initialState,
  reducers: {
    resetRoleDelete(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteRoleAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(deleteRoleAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IDeleteRoleResponse;
      })
      .addCase(deleteRoleAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IDeleteRoleResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetRoleDelete } = roleDeleteSlice.actions;

export default roleDeleteSlice.reducer;
